module.exports = __webpack_public_path__ + "img/worldline.bc1a14d8.png";